import { render, staticRenderFns } from "./SelectSellerField.vue?vue&type=template&id=48af01f0&scoped=true"
import script from "./SelectSellerField.vue?vue&type=script&lang=js"
export * from "./SelectSellerField.vue?vue&type=script&lang=js"
import style0 from "./SelectSellerField.vue?vue&type=style&index=0&id=48af01f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48af01f0",
  null
  
)

export default component.exports